import get from './envConfig';

export default {
  key_id: get('razor_pay_key_id'),
  transaction_description: 'Membership payment transaction',
  company_address: 'Bangalore, India',
  color_theme: '#3949AB'
};
